import { render } from "./workflow.vue?vue&type=template&id=4bd57a73&scoped=true"
import script from "./workflow.vue?vue&type=script&lang=js"
export * from "./workflow.vue?vue&type=script&lang=js"

import "./workflow.vue?vue&type=style&index=0&id=4bd57a73&scoped=true&lang=css"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd57a73"]])

export default __exports__